import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Keys extends BaseClass {
  Map: BaseClass;
  Firebase: BaseClass;

  constructor(obj: any = PERMISSIONS.Keys) {
    super(obj);
    this.Map = new BaseClass(obj.Map);
    this.Firebase = new BaseClass(obj.Firebase);
  }
}
